/** Типы листингов */
export enum EListingTypes {
  Cards = 'cards',
  List = 'list',
}
